'use strict';

import {
    addExportBtns,
    addSelectedCompanyHandler,
    getSelectedCompany,
    localeFormattedNumber,
    pjaxRedirect
} from "../jquery-functions-library";
import {element_exists, redesignDataTablesHeader} from "../functions";
import validate from "validate.js";

const Inputmask = require('inputmask');

export var fnViiaTable = function () {

    var tableName = '#datatable-viia-accounts';

    if (!element_exists(tableName)) return false;

    var contentColumn = '.container-datatable-viia-accounts';

    loadAccounts();
    initiateAttachDeactiveBankConnectionButton();

    addSelectedCompanyHandler(loadAccounts);

    addSelectedCompanyHandler(hideTable);

    addSelectedCompanyHandler(initiateAttachDeactiveBankConnectionButton);


    hideTable();

    function hideTable() {
        var selectedCompany = getSelectedCompany();

        var companyGuard = selectedCompany !== 'default';
        if (!companyGuard) {
            $(tableName).parents('.table-responsive').addClass('hidden');
            $(contentColumn).addClass('hidden');
        }
    }

    function initiateAutomaticTransferButton(table) {
        $('#attachAccountForm').validateFormListen({
                contra_account_id: {
                    presence: {
                        allowEmpty: false
                    }
                }
            },
            invalid => {
                $('#submitAttachAccountFormBtn').prop('disabled', invalid);
            });

        $(document).off('click', '.automatic-transfer-btn').on('click', '.automatic-transfer-btn', function () {
            const accountId = $(this).attr('data-account-id');

            if ($(this).attr('data-has-transfer') === '1') {
                $('#deactivateAutomaticTransferBtn').show();
                $('#submitAutomaticTransferBtn').html(allLangFiles.forms.save_changes);
                $('#transferFromDate').prop('disabled', true).val($(this).attr('data-transfer-from'));
            } else {
                $('#deactivateAutomaticTransferBtn').hide();
                $('#submitAutomaticTransferBtn').html(allLangFiles.viia.accounts.attach_cashbook);
                $('#transferFromDate').prop('disabled', false).val('');
            }

            const $modal = $('#modal-viia-automatic-transfer');
            $modal.modal('show');

            const selectedCompanyId = getSelectedCompany();
            const $cashbookSelect = $('#cashbookSelect');

            if (typeof $cashbookSelect.data('select2') !== 'undefined') {
                $cashbookSelect.select2('destroy');
                $cashbookSelect.empty();
            }

            $cashbookSelect.css('width', '100%');

            const self = this;

            $.ajax({
                url: `/viia/transactions/${selectedCompanyId}/cash-books/`,
                success(cashbooks) {
                    const data = cashbooks.map(cashbook => {
                        let selected = false;

                        if ($(this).attr('data-has-transfer') === '1') {
                            selected = $(this).attr('data-cash-book') == cashbook.journalNumber;
                        }

                        return {
                            id: cashbook.journalNumber,
                            text: cashbook.name,
                            selected: selected
                        };
                    });

                    $cashbookSelect.select2({
                        data: data,
                        placeholder: allLangFiles.viia.select_a_cashbook
                    });

                    const validateAutomaticTransferForm = () => {
                        $('#automaticTransferForm').validateForm({
                            cashbook: {
                                presence: {
                                    allowEmpty: false
                                }
                            },
                            transferFrom: {
                                presence: {
                                    allowEmpty: false
                                }
                            }
                        }, function (invalid) {
                            $('#submitAutomaticTransferBtn').prop('disabled', invalid);
                        });
                    };

                    const $transferFromDate = $('#transferFromDate');
                    $transferFromDate.datepicker({
                        format: 'yyyy-mm-dd'
                    });

                    $transferFromDate.off('change').on('change', function (e) {
                        validateAutomaticTransferForm();
                    });


                    $cashbookSelect.off('select2:select').on('select2:select', () => {
                        $cashbookSelect.trigger('change');

                        validateAutomaticTransferForm();
                    });

                    $('#deactivateAutomaticTransferBtn').off('click').on('click', function () {
                        $.ajax({
                            url: `/viia/${accountId}/deactivate-automatic-transfer`,
                            method: 'POST',
                            success() {
                                toastr.success(allLangFiles.viia.accounts.automatic_transfer_deactivated);

                                $('#datatable-viia-accounts').DataTable().ajax.reload();
                                $modal.modal('hide');
                            },
                            error() {
                                toastr.error(allLangFiles.forms.generic_error);
                            }
                        });
                    });

                    $('#submitAutomaticTransferBtn').off('click').on('click', function () {
                        const $form = $('#automaticTransferForm');

                        $.ajax({
                            url: $form.attr('action'),
                            method: 'POST',
                            data: {
                                accountId: accountId,
                                transferFromDate: $form.find($('#transferFromDate')).val(),
                                cashBookId: $form.find($('#cashbookSelect')).val()
                            },
                            success() {
                                if ($(self).attr('data-has-transfer') === '1') {
                                    toastr.success(allLangFiles.viia.accounts.automatic_transfer_updated);
                                } else {
                                    toastr.success(allLangFiles.viia.accounts.automatic_transfer_activated);
                                }

                                $('#datatable-viia-accounts').DataTable().ajax.reload();
                                $modal.modal('hide');
                            },
                            error() {
                                toastr.error(allLangFiles.forms.generic_error);
                            }
                        });
                    });
                },
                error() {
                    toastr.error(allLangFiles.forms.generic_error);
                }
            });
        });
    }

    function loadAccounts() {

        var selectedCompany = getSelectedCompany();

        let url = '/viia/' + selectedCompany + '/all';

        if ($.fn.dataTable.isDataTable(tableName)) {

            $(tableName).parents('.table-responsive').removeClass('hidden');
            $(contentColumn).removeClass('hidden');

            $(tableName).DataTable().ajax.url(url).load(function () {
                setTimeout(function () {
                    $(tableName).parent('.dataTables_scrollBody').css('width', '100%');
                }, 500);
            });
            return;
        }
        let columns = [
            {data: 'id'},
            {data: 'name'},
            {data: 'number'},
            {data: 'currency'},
            {
                data: 'booked.value', render: function (data, type, row) {
                    return localeFormattedNumber(data);
                }
            },
            {data: 'owner'},
            {
                data: 'available.value', render: function (data, type, row) {
                    return localeFormattedNumber(data);
                }
            },
            {
                data: 'features', render: function (data, type, row) {
                    let cell = [];
                    for (let key in data) {
                        if (!data.hasOwnProperty(key)) continue;

                        if (data[key]) {
                            cell.push(key);
                        }
                    }
                    return cell.join(', ');
                }
            },
            {
                data: 'lastSynchronized', render: function (data, type, row) {
                    if (!data) return '';
                    return moment(data).format('DD-MM-YYYY HH:MM:SS')
                }
            },
            {
                data: 'is_connected', render: function (data, type, row) {
                    if (data == "1") {
                        return `<button class="btn_viia_account_status max-w-40 img-circle text-success bg-success"></button>`
                    }
                    return `<button class="btn_viia_account_status max-w-40 img-circle text-danger bg-danger"></button>`
                }
            }
        ];

        if ($(tableName).attr('data-can-edit') === '1') {
            columns.push({
                data: 'attach_account',
                className: 'row-action'
            });
        }

        /*Rules for filling the columns*/
        var columnDefs = [
            {visible: false, targets: 0},
            {visible: false, targets: 7},
            {visible: true, targets: 9, class: 'text-center'},
        ];


        /*Important otherwise table misaligned*/
        $(tableName).css('width', '100%');
        $.fn.dataTable.moment('DD-MM-YYYY');

        var table = $(tableName).DataTable({

            language: allLangFiles.datatables,
            rowId: 'id',
            colReorder: true,
            stateSave: true,
            buttons: [
                {
                    extend: 'colvis',
                    text: allLangFiles.datatables.show_columns,
                    className: 'accounts-show-columns-btn btn btn-primary'
                }
            ],
            ajax: {
                url: url,
                dataSrc: function (json) {
                    console.log(json);
                    return json.data;
                },
                error: function (data) {
                    var errors = '';
                    if (data.responseJSON && data.responseJSON.errors) {
                        for (var datos in data.responseJSON.errors) {
                            errors += data.responseJSON.errors[datos] + '<br>';
                        }
                        toastr.error(errors);
                    } else if (data.responseJSON && data.responseJSON.message) {
                        toastr.error(data.responseJSON.message);
                    }
                }
            },
            columns: columns,
            columnDefs: columnDefs,
            scrollX: true,
            lengthMenu: [[-1, 10, 25, 50, 75, 100], [allLangFiles.datatables.all, 10, 25, 50, 75, 100]],
            initComplete: function (settings, json) {
                // $(tableName).parents('.table-responsive').removeClass('hidden');
                // $(contentColumn).removeClass('hidden');

                // table.draw();
            },
            drawCallback: function (settings) {
                $(tableName).parent('.dataTables_scrollBody').css('width', '100%');

                initiateAttachButton(this);
                initiateAutomaticTransferButton(this);
            },
        });

        $(tableName + ' tbody').off('click', 'tr td:not(.row-action)')
            .on('click', 'tr td:not(.row-action)', function () {
                var tableData = table.row($(this).parent()).data();
                console.log(tableData);
                pjaxRedirect(`/viia/transactions?account_id=${tableData.id}`);
            });
        //addSearchColumn(tableName, table);
        addExportBtns($(tableName));

        moveShowColumnsButton();
        const {$filterButtons} = redesignDataTablesHeader(tableName, true, null, false);
        $filterButtons.prepend($('#attachBankBtnGroup'));
    }

    $.fn.dataTable.ext.errMode = function (settings, helpPage, message) {
        // console.log(settings);
        // console.log(helpPage);
        // console.log(message);
        toastr.error('Error loading page');
        // pjaxRedirect(window.location);
        // $('#viia-page').trigger('click')//TODO find out if good idea
    };
}

function moveShowColumnsButton() {
    const button = $('.accounts-show-columns-btn');
    const rowAmountChooser = $('#datatable-viia-accounts_length');

    button.insertAfter(rowAmountChooser);

    button.removeClass();
    button.addClass('accounts-show-columns-btn')
        .addClass('btn')
        .addClass('btn-default');
}

function initiateAttachButton(table) {

    $('#attachAccountForm').validateFormListen({
            contra_account_id: {
                presence: {
                    allowEmpty: false
                }
            }
        },
        invalid => {
            $('#submitAttachAccountFormBtn').prop('disabled', invalid);
        });

    $(document).off('click', '.attach-account-btn').on('click', '.attach-account-btn', function () {
        if ($(this).attr('data-has-account') !== '1') {
            $('#detachAccountBtn').hide();
        } else {
            $('#detachAccountBtn').show();
        }

        $('#modal-viia-attach-account').modal('show');
        const accountId = $(this).attr('data-account-id');
        const dbAccountId = $(this).attr('data-db-account');

        $('#viia-account-id').val(accountId);

        $.ajax({
            url: '/viia/company-accounts',
            dataType: 'json',
            success(data) {
                const $accountSelect = $('#modal-viia-account-select');

                $accountSelect.select('destroy');
                $accountSelect.empty().trigger("change");

                $accountSelect.select2({
                    data: data.map(account => {
                        return {
                            id: account.id,
                            text: `${account.accountNumber} - ${account.name}`
                        }
                    })
                });

                const chosenAccount = data.find(account => Number(dbAccountId) === account.accountNumber);

                if (chosenAccount) {
                    $accountSelect.val(chosenAccount.id).trigger('change');
                }

                $accountSelect.css('width', '100% !important');
            }
        });

        $(document).off('click', '#detachAccountBtn').on('click', '#detachAccountBtn', function () {
            const accountId = $('#viia-account-id').val();

            $.ajax({
                url: `viia/detach-account/${accountId}`,
                method: 'POST',
                success() {
                    toastr.success(allLangFiles.viia.accounts.account_detached);
                    $('#modal-viia-attach-account').modal('hide');
                    $(table).DataTable().ajax.reload();
                },
                error() {
                    toastr.error(allLangFiles.forms.generic_error);
                }
            });
        });

        $("#submitAttachAccountFormBtn").off('click').on('click', function () {
            let $form = $('#attachAccountForm');
            const formData = $form.serialize();
            const url = $form.attr('action');

            $.ajax({
                url: url,
                method: 'POST',
                data: formData,
                success() {
                    toastr.success(allLangFiles.viia.accounts.account_attached);
                    $('#modal-viia-attach-account').modal('hide');
                    $(table).DataTable().ajax.reload();
                },
                error() {
                    toastr.error(allLangFiles.forms.generic_error);
                }
            });
        });
    });

}

/**
 * Called when loading table and page.
 * Checks first if the button element for deactivation exists and if so, checks if the company has a valid bank connection.
 */
function initiateAttachDeactiveBankConnectionButton(){
   let deactiveViiaToken = '#btn_deactivate_bank_connection';
   if (!element_exists(deactiveViiaToken)) return false;

   hasValidViiaConnection();
}

/**
 * Checks if the company has a valid bank connection.
 * If the connection is valid, trigger function to show the deactive connection button.
 */
function hasValidViiaConnection(){
    let selectedCompany = getSelectedCompany();
    $.ajax({
        type: 'get',
        url: '/viia/' + selectedCompany + '/has-valid-connection',
        success: function (response) {
            if(response == true){
                console.log('hasValidViiaConnection: ' + response);
                showDeactiveConnectionButton(response);
            } else {
                unsetDeactiveConnectionButton();
            }
        },
        error: function (response) {
           return response;
        }
    });
}

/**
 * If the user has no valid connection, the button is hidden and the data-href is unset.
 */
function unsetDeactiveConnectionButton(){
    $('.container-datatable-viia-accounts-deactive-connection').addClass('hidden');
    $('#btn_deactivate_bank_connection').attr('data-href',"");
}

/**
 * If the user clicks on deactive connection button, show confirmation dialog and deactivate connection.
 */
function showDeactiveConnectionButton(){
    let selectedCompany = getSelectedCompany();

    $('#btn_deactivate_bank_connection').off('click').on('click', function (e) {
            e.preventDefault();

            var lang = allLangFiles.viia.deactivate.js;
        
            $.confirm({
                title: lang.deactive_bank_connection_title,
                content: lang.deactive_bank_connection_confirm,
                theme: 'supervan',
                columnClass: 'col-md-12',
                backgroundDismiss: true,
                buttons: {
                    Ja: {
                        action: function () {
                            deactivateViiaConnection();
                            $('#datatable-viia-accounts').DataTable().ajax.reload();
                        },
                        text: lang.yes
                    },
                    Nej: {
                        text: lang.no
                    }
                }
            });    
    });
   
   $('#btn_deactivate_bank_connection').attr('data-href', '/viia/' + selectedCompany + '/deactive-connection');
   $('.container-datatable-viia-accounts-deactive-connection').removeClass('hidden');
}

/**
 * Deactivate the connection by setting disabled_at on the token.
 */
function deactivateViiaConnection(){
    let selectedCompany = getSelectedCompany();

    $.ajax({
        type: 'POST',
        url: '/viia/' + selectedCompany + '/deactive-connection',
        success: function () {
            toastr.success(allLangFiles.viia.deactivate.deactivate_bank_connection_success);
        },
        error: function (response) {
            if (response.status === 404) {
                toastr.error(allLangFiles.viia.deactivate.deactive_bank_connection_no_token);
                return;
            }

            toastr.error(allLangFiles.viia.deactivate.deactivate_bank_connection_failed);
        }
    });
}
